import { Button } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";

interface ButtonProps {
  label: string;
  text: string | number;
  onIncrease: () => void;
  onDecrease: () => void;
  onToggleDialog: () => void;
  isNumSymbol?: boolean;
}

const AppButtonGroup: React.FC<ButtonProps> = ({
  label,
  text,
  isNumSymbol = false,
  onDecrease,
  onIncrease,
  onToggleDialog,
}) => {
  const isTextNaN = isNaN(Number(text));
  return (
    <div className="app-button-group">
      <p>{label}</p>
      <div className="app-button-group-btn">
        <Button onClick={onDecrease} sx={{ color: "white" }}>
          {isNumSymbol ? (
            <RemoveIcon sx={{ color: "white", fontSize: 18 }} />
          ) : (
            <KeyboardArrowLeftIcon sx={{ color: "white", fontSize: 18 }} />
          )}
        </Button>
        <Button
          onClick={onToggleDialog}
          sx={{ color: "white", textTransform: "none" }}
        >
          {isTextNaN && isNumSymbol ? "1" : text}
        </Button>
        <Button sx={{ color: "white" }} onClick={onIncrease}>
          {isNumSymbol ? (
            <AddIcon sx={{ fontSize: 18 }} />
          ) : (
            <KeyboardArrowRightIcon sx={{ fontSize: 18 }} />
          )}
        </Button>
      </div>
    </div>
  );
};

export default AppButtonGroup;
